import { render, staticRenderFns } from "./AppCenter.vue?vue&type=template&id=38ac94bf&scoped=true&"
import script from "./AppCenter.vue?vue&type=script&lang=ts&"
export * from "./AppCenter.vue?vue&type=script&lang=ts&"
import style0 from "./AppCenter.vue?vue&type=style&index=0&id=38ac94bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ac94bf",
  null
  
)

export default component.exports